import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@material-ui/core';

import useStyles from './useStyles';

const LoanPayments = props => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { carPayment, studentLoanPayment, mortgagePayment, creditCardPayment, othelLoansPayment, loanPayments } = props;

  return (
    <Box className={classes.paper}>
      <Typography variant="body1" color="inherit" className={classes.label}>
        {t('components.Quiz.SummaryPage.LoansPayment.label')}
      </Typography>
      <Box my={2}>
        <Typography variant="h1">
          <NumberFormat value={loanPayments} displayType="text" thousandSeparator decimalScale={0} prefix="$" />
        </Typography>
      </Box>
      <Typography color="secondary" variant="body2">
        {t('components.Quiz.SummaryPage.LoansPayment.breakdown')}
      </Typography>
      <Box display="flex" mt={0.8}>
        <Box width="30%">
          <Typography color="secondary" variant="body1" className={classes.bold}>
            <NumberFormat value={mortgagePayment} displayType="text" thousandSeparator decimalScale={0} prefix="$" />
          </Typography>
        </Box>
        <Box width="70%">
          <Typography color="secondary" variant="body2">
            {t('components.Quiz.SummaryPage.LoansPayment.mortgagePayment')}
          </Typography>
        </Box>
      </Box>
      <Box display="flex" mt={0.8}>
        <Box width="30%">
          <Typography color="secondary" variant="body1" className={classes.bold}>
            <NumberFormat value={carPayment} displayType="text" thousandSeparator decimalScale={0} prefix="$" />
          </Typography>
        </Box>
        <Box width="70%">
          <Typography color="secondary" variant="body2">
            {t('components.Quiz.SummaryPage.LoansPayment.carPayment')}
          </Typography>
        </Box>
      </Box>
      <Box display="flex" mt={0.8}>
        <Box width="30%">
          <Typography color="secondary" variant="body1" className={classes.bold}>
            <NumberFormat value={studentLoanPayment} displayType="text" thousandSeparator decimalScale={0} prefix="$" />
          </Typography>
        </Box>
        <Box width="70%">
          <Typography color="secondary" variant="body2">
            {t('components.Quiz.SummaryPage.LoansPayment.studentLoanPayment')}
          </Typography>
        </Box>
      </Box>
      <Box display="flex" mt={0.8}>
        <Box width="30%">
          <Typography color="secondary" variant="body1" className={classes.bold}>
            <NumberFormat value={creditCardPayment} displayType="text" thousandSeparator decimalScale={0} prefix="$" />
          </Typography>
        </Box>
        <Box width="70%">
          <Typography color="secondary" variant="body2">
            {t('components.Quiz.SummaryPage.LoansPayment.creditCardPayment')}
          </Typography>
        </Box>
      </Box>
      <Box display="flex" mt={0.8}>
        <Box width="30%">
          <Typography color="secondary" variant="body1" className={classes.bold}>
            <NumberFormat value={othelLoansPayment} displayType="text" thousandSeparator decimalScale={0} prefix="$" />
          </Typography>
        </Box>
        <Box width="70%">
          <Typography color="secondary" variant="body2">
            {t('components.Quiz.SummaryPage.LoansPayment.othelLoansPayment')}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

LoanPayments.propTypes = {
  carPayment: PropTypes.number.isRequired,
  studentLoanPayment: PropTypes.number.isRequired,
  mortgagePayment: PropTypes.number.isRequired,
  creditCardPayment: PropTypes.number.isRequired,
  othelLoansPayment: PropTypes.number.isRequired,
  loanPayments: PropTypes.number.isRequired,
};

export default LoanPayments;



// WEBPACK FOOTER //
// ./src/components/QuizPage/components/SummaryPage/components/LoanPayments/LoanPayments.js